module.exports = __webpack_public_path__ + "static/step6-9398f3f3029588ff54d315544e4507e5.png";